import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export interface IParkStep {
  id: number;
  pre: string;     // primera línea (regular)
  strong: string;  // segunda línea (negrita)
}

// Pasos del flujo de Parques completo (el modal oculta los que no aplican al proveedor elegido).
export const PARK_STEPS: IParkStep[] = [
  { id: 1, pre: 'Selección de', strong: 'Hotel' },
  { id: 2, pre: 'Selección de', strong: 'Plan de Comidas' },
  { id: 3, pre: 'Selección de', strong: 'Tickets' },
  { id: 4, pre: 'Selección de', strong: 'Días' },
  { id: 5, pre: 'Resumen', strong: 'Carrito' },
];

@Component({
  selector: 'usb-park-steps',
  templateUrl: './park-steps.component.html',
  styleUrls: ['./park-steps.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParkStepsComponent {
  @Input() steps: IParkStep[] = PARK_STEPS;
  @Input() current = 1;
  // Último paso al que se puede volver (los siguientes no están habilitados todavía).
  @Input() maxReached = 1;

  @Output() goTo = new EventEmitter<number>();

  canGo(step: IParkStep): boolean {
    return step.id <= this.maxReached && step.id !== this.current;
  }

  onClick(step: IParkStep): void {
    if (this.canGo(step)) {
      this.goTo.emit(step.id);
    }
  }
}
